//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faArrowCircleUp,
  faChartColumn,
  faReceipt,
} from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'ReferralBenefits',
  data() {
    return {
      steps: [
        {
          icon: faArrowCircleUp,
          color: 'warning',
          heading: this.$t(this.$wbr('affiliate_program.benefits_one_year_heading')),
          text: this.$t(this.$wbr('affiliate_program.benefits_one_year_text')),
        },
        {
          icon: faChartColumn,
          color: 'blue',
          heading: this.$t(this.$wbr('affiliate_program.benefits_dashboard_heading')),
          text: this.$t(this.$wbr('affiliate_program.benefits_dashboard_text')),
        },
        {
          icon: faReceipt,
          color: 'aqua',
          heading: this.$t(this.$wbr('affiliate_program.benefits_monthly_payouts_heading')),
          text: this.$t(this.$wbr('affiliate_program.benefits_monthly_payouts_text')),
        },
      ],
    };
  },
};
